export const LEGAL_URLS = {
  CGU: "https://drive.google.com/file/d/17Ges9OKJynq2RtLYPmwQW1lssf24uprq/view?usp=drive_link",
  PRIVACY_POLICY: "https://drive.google.com/file/d/1fNFulkn9zjnGIuNFBVAp6a5gJmYUyTho/view?usp=drive_link",
  SUBCONTRACTING_AGREEMENT: "https://drive.google.com/file/d/1SFOa2RfOCMlyNCV3GrsCmlyHK_8AhbHQ/view?usp=drive_link",
  LEGAL_NOTICE: "https://drive.google.com/file/d/1svpwhJCowIEzJccKDoxfzm78t3UjjgoL/view?usp=drive_link",
};
